import { isServer } from "../../utils/environmentDetection/library";

const ACC_ENV_DEFAULT = "https://www.cbc.ca/account-centre/a";
const ACC_ENV_LOCAL = "https://local.cbc.ca:448/a";

/**
 * Gets the Account center public path (ACC_ENV). The returned url should start with http:// or https://
 * and include the base path for loading membership assets i.e. https://www.cbc.ca/account-centre/a
 *
 * The account centre public path can be changed using the ACC_ENV environment variable. ACC_ENV can be set
 * in the Openshift configmaps for a deployed Ocelot environment. ACC_ENV can also be set when running ocelot
 * locally (e.g. `ACC_ENV=https://www.qa.nm.cbc.ca/path-to-acc-env/a npm run start:debug`)
 *
 * @returns {string} Account centre public path url (e.g. "https://www.cbc.ca/account-centre/a")
 */
export const getAccountPublicPath = () => {
    const ACC_ENV = isServer() ? process.env.ACC_ENV : window?.__ACC_ENV__;

    if (ACC_ENV && ACC_ENV === "local") {
        return ACC_ENV_LOCAL;
    }

    if (ACC_ENV && ACC_ENV.length > 0) {
        return ACC_ENV;
    }

    return ACC_ENV_DEFAULT;
};
